import { createFileRoute, notFound } from "@tanstack/react-router";
import checkoutStyles from "../styles/checkout.css?url";
import shopStyles from "../styles/shop.css?url";
import shopCheckoutStyles from "../styles/shop-checkout.css?url";
import { CheckoutPage } from "../components/membership/checkout-page";
import { DemoPaymentPage } from "../components/membership/demo-payment-page";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { keepSearch } from "../lib/search";
import { loadCheckout } from "../server/membership";

/**
 * The payment page (/checkout): a whole document with a minimal layout, private and never indexed
 *. Its order loads in the browser with the payment's own token.
 */
export const Route = createFileRoute("/checkout")({
  validateSearch: keepSearch,
  loader: async () => {
    const data = await loadCheckout();
    if (!data) throw notFound();
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      withStylesheet(
        withStylesheet(
          creatorPageHead(shell, {
            pathname: "/checkout",
            title: `Payment | ${loaderData.creatorName}`,
            description: "Your content, your community, your corner of the internet.",
            noindex: true,
          }),
          checkoutStyles,
        ),
        shopStyles,
      ),
      shopCheckoutStyles,
    );
  },
  component: Checkout,
});

function Checkout() {
  const data = Route.useLoaderData();
  const search = Route.useSearch();
  if (typeof search.demo_session === "string") return <DemoPaymentPage kind="plan" />;
  return <CheckoutPage creatorName={data.creatorName} podcast={data.podcast} />;
}
